/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import { MagnifyingGlassIcon } from "@heroicons/react/20/solid";

const CommuneAutocomplete = ({
  items,
  communeQueryHandler,
  communePlaceholder,
  noResultsText,
  isDesktop,
  isFooter,
  handleFocus,
  handleBlur,
}) => {
  const [inputValue, setInputValue] = useState("");
  const [filteredItems, setFilteredItems] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const inputRef = useRef(null);
  const [querySelected, setQuerySelected] = useState("");

  function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    }, [value]);
    return ref.current;
  }

  const prevValue = usePrevious(inputValue);

  useEffect(() => {
    if (items && items.length > 0) {
      setFilteredItems(
        items.filter((item) =>
          item.toLowerCase().includes(inputValue.toLowerCase())
        )
      );
    }
  }, [inputValue, items]);

  useEffect(() => {
    if (inputValue === "" && prevValue !== "") {
      setIsOpen(false);
    }
  }, [inputValue]);

  const handleClickOutside = (event) => {
    if (
      inputRef.current &&
      !inputRef.current.contains(event.target) &&
      !inputValue
    ) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (querySelected.length > 0) {
      communeQueryHandler(querySelected);
    }
  }, [querySelected]);

  const handleInputChange = (e) => {
    if (e.target.value === "") {
      communeQueryHandler("reset");
    }
    setInputValue(e.target.value);
    setIsOpen(true);
  };

  const handleItemClick = (value) => {
    setInputValue(value);
    setQuerySelected(value);
    setIsOpen(false);
  };

  const hasNoResults = filteredItems.length === 0;

  const inputWidth = (isDesktop) => {
    if (isDesktop && !isFooter) {
      return { width: "546px" };
    } else if (isDesktop && isFooter) {
      return { width: "764px" };
    } else {
      return { width: "100%" };
    }
  };

  return (
    <div className="relative mr-4" style={inputWidth(isDesktop)}>
      <input
        className="relative w-full cursor-default h-12 rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 text-left shadow-sm focus:border-focus-ring focus:outline-none focus:ring-1 focus:ring-focus-ring sm:text-sm"
        value={inputValue}
        onChange={handleInputChange}
        placeholder={communePlaceholder}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
      {isOpen && (
        <ul className="absolute z-10 mt-1 max-h-72 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
          {filteredItems.map((item) => (
            <li
              key={item}
              className="relative cursor-default select-none py-2 pl-8 pr-4 hover:bg-field-hover"
              onClick={() => handleItemClick(item)}
            >
              {item}
            </li>
          ))}
          {hasNoResults && (
            <li className="p-2">
              {noResultsText} "{inputValue}"
            </li>
          )}
        </ul>
      )}
      <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
        <MagnifyingGlassIcon className="h-5 w-5" aria-hidden="true" />
      </span>
    </div>
  );
};

export default CommuneAutocomplete;
